export const contactTypes = Object.freeze({
  email: 'EMAIL',
  sms: 'SMS',
  voice: 'VOICE'
});

export const INPUT_TYPES = Object.freeze({
  PHONE: 'phone',
  EMAIL: 'email'
});

export const VIEW_TYPES = Object.freeze({
  ENROLL: 'ENROLL',
  MAINTENANCE: 'MAINTENANCE'
});

export const CONTACT_POINTS = Object.freeze({
  SMS: { id: 'SMS', name: 'Text Message' },
  VOICE: { id: 'VOICE', name: 'Voice Message' }
});

export const FIELD_NAMES = Object.freeze({
  SECURITY: 'security',
  IS_SUBMITTING: 'isSubmitting'
});

export const SUBMIT_TYPES = Object.freeze({
  SECURITY_QUESTIONS: '#securityQuestions',
  SECURITY_CONTACTS: '#securityContacts',
  NEW_PASSWORD: '#newPassword',
  SEND_CODE: 'sendCode',
  VERIFY_CODE: 'verifyCode',
  REMOVE_MOBILE_CONTACT: 'removeMobileContact',
  LOGOUT: 'logout',
  COMPLETE: 'complete'
});

export const STORAGE_ITEMS = Object.freeze({
  FIRST_TIME_SETUP: 'firstTimeSetup',
  TEMP_PASSWORD: 'tempPassword',
  REDIRECT_TOKEN: 'redirecttoken'
});

export const STEPS = Object.freeze({
  PASSWORD: 'password',
  QUESTIONS: 'questions',
  CONTACT: 'contact'
});

export const VRU_DELAY_OPTIONS = [
  { id: 2, name: '2 seconds' },
  { id: 4, name: '4 seconds' },
  { id: 6, name: '6 seconds' },
  { id: 8, name: '8 seconds' },
  { id: 10, name: '10 seconds' },
  { id: 12, name: '12 seconds' },
  { id: 14, name: '14 seconds' },
  { id: 16, name: '16 seconds' },
  { id: 18, name: '18 seconds' }
];

export const SECURITY_QUESTIONS = 'Security Questions';
export const SECURITY_CONTACTS = 'Security Contacts';
export const NEW_PASSWORD = 'New Password';
export const FALLBACK_VRU_DELAY = 2;
export const QUESTION = 'Question';
export const SMS_NUMBER_MAX = 14;
export const VOICE_CALL_NUMBER_FORMAT = '$1$2$3';

export const REDUCER_ACTIONS = {
  HANDLE_ERROR: 'handleError',
  HANDLE_INPUT_CHANGE: 'handleInputChange',
  HANDLE_RESPONSE: 'handleResponse',
  SET_SENDING: 'setSending',
  VERIFY_CODE: 'verifyCode'
};
